import React from "react";
import { Box } from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import { formatDate } from "../../../../helpers/commonHelper";

const ChemoSessionDetails = ({ preChemoData, postChemoData }) => {
  return (
    <Box className="tp-section">
      {/* ============================================== */}
      {/* PRE-CHEMO CHECK-UP SECTION */}
      {/* ============================================== */}
      {preChemoData && (
        <>
          <h5 className="mb-3">Pre-Chemo Check-up</h5>
          <div className="upload-clinical">
            {/* Date and ECOG Status */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date of Check Up</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.check_up_date)}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>ECOG PS (0/1/2/3/4/5)</Form.Label>
                <p className="view-value">
                  {preChemoData?.ecog_ps || "N/A"}
                </p>
              </Col>
            </Row>

            {/* Recent Lab Results Section */}
            <h6 className="mt-4 mb-3">Recent Lab Results</h6>

            {/* Haemoglobin */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Haemoglobin (g/dL)</Form.Label>
                <p className="view-value">
                  {preChemoData?.haemoglobin || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.haemoglobin_date)}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>
                  Total Leucocyte Count (cells/mm³)
                </Form.Label>
                <p className="view-value">
                  {preChemoData?.leucocyte || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.leucocyte_date)}
                </p>
              </Col>
            </Row>

            {/* Absolute Neutrophil Count */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>
                  Absolute Neutrophil Count (ANC)
                </Form.Label>
                <p className="view-value">
                  {preChemoData?.neutrophil || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.neutrophil_date)}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>
                  Platelet Count (lakh/μL)
                </Form.Label>
                <p className="view-value">
                  {preChemoData?.platelet || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.platelet_date)}
                </p>
              </Col>
            </Row>

            {/* Serum Creatinine */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>
                  Serum Creatinine (mg/dL)
                </Form.Label>
                <p className="view-value">
                  {preChemoData?.serum_creatinine || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(
                    preChemoData?.serum_creatinine_date
                  )}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Blood Urea Nitrogen</Form.Label>
                <p className="view-value">
                  {preChemoData?.blood_urea_nitrogen || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(
                    preChemoData?.blood_urea_nitrogen_date
                  )}
                </p>
              </Col>
            </Row>

            {/* Serum Bilirubin */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Serum Bilirubin</Form.Label>
                <p className="view-value">
                  {preChemoData?.serum_bilirubin || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(
                    preChemoData?.serum_bilirubin_date
                  )}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>SGOT</Form.Label>
                <p className="view-value">
                  {preChemoData?.sgot || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.sgot_date)}
                </p>
              </Col>
            </Row>

            {/* SGPT */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>SGPT</Form.Label>
                <p className="view-value">
                  {preChemoData?.sgpt || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.sgpt_date)}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Sodium</Form.Label>
                <p className="view-value">
                  {preChemoData?.sodium || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.sodium_date)}
                </p>
              </Col>
            </Row>

            {/* Potassium */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Potassium</Form.Label>
                <p className="view-value">
                  {preChemoData?.potassium || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(preChemoData?.potassium_date)}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Cancer markers</Form.Label>
                <p className="view-value">
                  {preChemoData?.cancer_markers || "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date</Form.Label>
                <p className="view-value">
                  {formatDate(
                    preChemoData?.cancer_markers_date
                  )}
                </p>
              </Col>
            </Row>
          </div>
        </>
      )}

      {/* ============================================== */}
      {/* POST-CHEMO DETAILS SECTION */}
      {/* ============================================== */}
      {postChemoData && (
        <>
          <h5 className="mb-3 mt-4">Post-Chemo Details</h5>
          <div className="upload-clinical">
            {/* Chemotherapy Administration Details */}
            <h6 className="mb-3">
              Chemotherapy Administration Details
            </h6>

            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Date of administration</Form.Label>
                <p className="view-value">
                  {formatDate(postChemoData?.referral_date)}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Cycle Number</Form.Label>
                <p className="view-value">
                  {postChemoData?.cycle_number || "N/A"}
                </p>
              </Col>
            </Row>

            {/* Chemotherapy Drugs and Dosage administered */}
            <h6 className="mt-4 mb-3">
              Chemotherapy Drugs and Dosage administered
            </h6>

            {postChemoData?.drug_mo_details &&
              postChemoData.drug_mo_details.length > 0 ? (
              postChemoData.drug_mo_details.map((drug, idx) => (
                <Row className="mb-3" key={idx}>
                  <Col md={3} sm={6} xs={12}>
                    <Form.Label>Drug Name</Form.Label>
                    <p className="view-value">
                      {drug?.drug_name || "N/A"}
                    </p>
                  </Col>

                  <Col md={3} sm={6} xs={12}>
                    <Form.Label>Dose administered</Form.Label>
                    <p className="view-value">
                      {drug?.dose_administered || "N/A"}
                    </p>
                  </Col>

                  <Col md={3} sm={6} xs={12}>
                    <Form.Label>
                      Route of Administration
                    </Form.Label>
                    <p className="view-value">
                      {drug?.administration_route || "N/A"}
                    </p>
                  </Col>
                </Row>
              ))
            ) : (
              <Row className="mb-3">
                <Col md={3} sm={6} xs={12}>
                  <p className="view-value">
                    No drug details available
                  </p>
                </Col>
              </Row>
            )}

            {/* Administration Details */}
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Infusion Rate/Duration</Form.Label>
                <p className="view-value">
                  {postChemoData?.chemo_infusion_rate_duration ||
                    "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Diluent/Volume</Form.Label>
                <p className="view-value">
                  {postChemoData?.chemo_diluent_volume ||
                    "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Timing</Form.Label>
                <p className="view-value">
                  {postChemoData?.chemo_timing || "N/A"}
                </p>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Delivery Method</Form.Label>
                <p className="view-value">
                  {postChemoData?.chemo_delivery_method ||
                    "N/A"}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>
                  Notes/Special Instructions
                </Form.Label>
                <p className="view-value">
                  {postChemoData?.chemo_notes_special_instructions ||
                    "N/A"}
                </p>
              </Col>
            </Row>

            {/* Premedications Given */}
            <h6 className="mt-4 mb-3">Premedications Given</h6>

            {postChemoData?.premedication_mo_details &&
              postChemoData.premedication_mo_details.length >
              0 ? (
              postChemoData.premedication_mo_details.map(
                (premed, idx) => (
                  <Row className="mb-3" key={idx}>
                    <Col md={3} sm={6} xs={12}>
                      <Form.Label>Drug Type</Form.Label>
                      <p className="view-value">
                        {premed?.drug_type || "N/A"}
                      </p>
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <Form.Label>Drug Name</Form.Label>
                      <p className="view-value">
                        {premed?.drug_name || "N/A"}
                      </p>
                    </Col>

                    <Col md={3} sm={6} xs={12}>
                      <Form.Label>Dose administered</Form.Label>
                      <p className="view-value">
                        {premed?.dose_administered || "N/A"}
                      </p>
                    </Col>

                    <Col md={3} sm={6} xs={12}>
                      <Form.Label>
                        Route of Administration
                      </Form.Label>
                      <p className="view-value">
                        {premed?.administration_route || "N/A"}
                      </p>
                    </Col>
                  </Row>
                )
              )
            ) : (
              <Row className="mb-3">
                <Col md={3} sm={6} xs={12}>
                  <p className="view-value">
                    No premedication details available
                  </p>
                </Col>
              </Row>
            )}

            {/* Hydration Given */}
            <h6 className="mt-4 mb-3">Hydration Given</h6>

            {/* Pre-Chemo Hydration */}
            <h6 className="mb-2">Pre-Chemo Hydration</h6>
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Fluid Type</Form.Label>
                <p className="view-value">
                  {postChemoData?.pre_chemo_hydration_fluid_type ||
                    "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Volume</Form.Label>
                <p className="view-value">
                  {postChemoData?.pre_chemo_hydration_fluid_volume ||
                    "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Duration</Form.Label>
                <p className="view-value">
                  {postChemoData?.pre_chemo_hydration_fluid_duration ||
                    "N/A"}
                </p>
              </Col>
            </Row>

            {/* Post-Chemo Hydration */}
            <h6 className="mt-3 mb-2">Post-Chemo Hydration</h6>
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Fluid Type</Form.Label>
                <p className="view-value">
                  {postChemoData?.post_chemo_hydration_fluid_type ||
                    "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Volume</Form.Label>
                <p className="view-value">
                  {postChemoData?.post_chemo_hydration_fluid_volume ||
                    "N/A"}
                </p>
              </Col>

              <Col md={3} sm={6} xs={12}>
                <Form.Label>Duration</Form.Label>
                <p className="view-value">
                  {postChemoData?.post_chemo_hydration_fluid_duration ||
                    "N/A"}
                </p>
              </Col>
            </Row>

            {/* Additional Details */}
            <h6 className="mt-4 mb-3">Additional Details</h6>

            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>
                  Any Significant Side Effects Reported
                </Form.Label>
                <p className="view-value">
                  {postChemoData?.significant_side_effects ||
                    "N/A"}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Medicine Prescribed</Form.Label>
                <p className="view-value">
                  {postChemoData?.medicine_prescribed || "N/A"}
                </p>
              </Col>
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Discharge Summary</Form.Label>
                <p className="view-value">
                  {postChemoData?.discharge_summary || "N/A"}
                </p>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={3} sm={6} xs={12}>
                <Form.Label>Name of Doctor</Form.Label>
                <p className="view-value">
                  {postChemoData?.doctor_name || "N/A"}
                </p>
              </Col>
            </Row>
          </div>
        </>
      )}
    </Box>
  );
};

export default ChemoSessionDetails;
